import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { sizes } from "../../../enums";
import { removeProps, whitelistStyles } from "../hoc";
import { compose } from 'react-recompose';
import { Form } from 'semantic-ui-react';
import { isComponentDisabled } from "../checkbox-like/checkbox";
import Radio from "../checkbox-like/radio";
import Label from "../label";
var RadioGroup = createComponent({
  displayName: 'RadioGroup',
  propTypes: {
    children: PropTypes.arrayOf(PropTypes.element),
    // Radio only
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      description: PropTypes.string,
      isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    })),
    label: PropTypes.string,
    selectedValue: PropTypes.string.isRequired,
    // representative of radio value prop, will override individual isSelected prop of radio
    isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    layout: PropTypes.oneOf(['horizontal', 'vertical']),
    onChange: PropTypes.func.isRequired,
    // will override any input's onChange handler
    spacing: PropTypes.oneOf(sizes.S_M_L),
    gutterSize: PropTypes.oneOf(sizes.S_M_L)
  },
  defaultProps: {
    children: null,
    options: [],
    label: null,
    selectedValue: null,
    isDisabled: false,
    layout: 'vertical',
    spacing: sizes.MEDIUM,
    gutterSize: sizes.MEDIUM
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var groupUIProps = {};
    var controls;

    if (props.layout === 'horizontal') {
      groupUIProps.inline = true;
    } else if (props.layout === 'vertical') {
      groupUIProps.grouped = true;
    }

    logger.warn('Children cannot be defined with "options", please choose one or the other, in RadioGroup', !_.isEmpty(props.options) && !_.isEmpty(React.Children.toArray(props.children)));

    if (!_.isEmpty(props.options)) {
      controls = extractControlsFromOptions(props);
    }

    if (!_.isEmpty(props.children)) {
      controls = extractControlsFromChildren(props);
    }

    var fields = _mapInstanceProperty(_).call(_, controls, function (radio) {
      return /*#__PURE__*/React.createElement(Form.Field, {
        key: radio.props.value
      }, radio);
    });

    var radioGroupClassnames = classnames('ck-checkbox-group', props.layout + "-spacing", props.spacing);
    return /*#__PURE__*/React.createElement("div", {
      className: radioGroupClassnames,
      style: props.style
    }, /*#__PURE__*/React.createElement(Form, null, props.label ? /*#__PURE__*/React.createElement(Label, {
      text: props.label
    }) : null, /*#__PURE__*/React.createElement(Form.Group, groupUIProps, fields)));
  }
});

function extractControlsFromChildren(props) {
  var _context;

  var componentIsDisabled = isComponentDisabled(props.isDisabled);
  return _mapInstanceProperty(_context = React.Children).call(_context, React.Children.toArray(props.children), function (radio) {
    return /*#__PURE__*/React.cloneElement(radio, {
      onChange: props.onChange,
      isSelected: props.selectedValue === radio.props.value,
      isDisabled: componentIsDisabled || isComponentDisabled(radio.props.isDisabled),
      gutterSize: radio.props.gutterSize !== undefined ? radio.props.gutterSize : props.gutterSize
    });
  });
}

function extractControlsFromOptions(props) {
  var componentIsDisabled = isComponentDisabled(props.isDisabled);
  return _mapInstanceProperty(_).call(_, props.options, function (option) {
    return /*#__PURE__*/React.createElement(Radio, {
      isSelected: props.selectedValue === option.value,
      isDisabled: componentIsDisabled || isComponentDisabled(option.isDisabled),
      value: option.value,
      onChange: props.onChange,
      label: option.label,
      description: option.description,
      gutterSize: props.gutterSize
    });
  });
}

export var PrivateRadioGroup = RadioGroup;
export default compose(whitelistStyles())(RadioGroup);
//# sourceMappingURL=index.js.map